<template>  
  <div class="about-main-container">
    <div class="about-sections-container" v-for="(block, index) in blocks" :key="index + '_'">
      <div v-if="block.type === 'image_banner'">
        <banner :block="block"></banner>
        <glossaryItems :items="glossary_items"></glossaryItems>
      </div>
    </div>
  </div>
</template>

<script>
import GlossaryItems from '@/scripts/components/sections/GlossaryItems.vue'
import Banner from '@/scripts/components/basic/Banner.vue'

export default {
  name: 'Glossary',
  components: { GlossaryItems , Banner},
  props: {
    blocks: {
      type: Array,
      default: () => []
    },
    glossary_items: {
      type: Object,
      default: () => []
    }
  }
}
</script>